import {SOPutMessage} from '../../core/message/so-put-message';
import {MessageCore} from './message.core';
import {SOGetMessage} from '../../core/message/so-get-message';
import {FormField, SelectionOption} from 'lionheartland';
import {putMessageFormFieldOptions} from './put-message-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';

export class RAPutMessage extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putMessageFormFieldOptions);

  RequestClass = SOPutMessage

  constructor(
    public entityCore: MessageCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}